import {
  REQUEST_PARTNER_LIST,
  REQUEST_PARTNER_LIST_FOR_CREATE,
  REQUEST_PARTNER,
} from './mutation-types'

import axiosInst from '@/utility/axiosInst';

export default {
  requestCreatePartner({}, payload) {
    return axiosInst.springAxiosInst.post("/admin/partner/create-partner", payload)
      .then((res) => {
        return res.data
      })
  },
  requestPartnerList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get("/admin/partner/partner-list", {
      params: {
        page: currentPage,
        searchType: searchType,
        searchWord : searchWord
      }
    }).then((res) => {
      commit(REQUEST_PARTNER_LIST, res.data)
    })
  },
  requestPartner({commit}, partnerSeq) {
    return axiosInst.springAxiosInst.get(`/admin/partner/partner/${partnerSeq}`)
    .then((res) => {
      commit(REQUEST_PARTNER, res.data)
    })
  },
  requestSavePartner({}, payload) {
    console.log('requestSavePartner', payload);
    return axiosInst.springAxiosInst.post("/admin/partner/save-partner", payload)
      .then((res) => {
        return res.data
      })
  },
  requestDeletePartners({}, payload) {
    return axiosInst.springAxiosInst.post('/admin/partner/delete-partners', payload)
    .then((res) => {
      return res.data
    })
  },
  requestPartnersForCreate({commit}, parent) {
    return axiosInst.springAxiosInst.get('/admin/partner/get-all-partners', {
    }).then((res) => {
      commit(REQUEST_PARTNER_LIST_FOR_CREATE, res.data)
    })
  },
}